import React from 'react';
import { useNumberFormatter } from '../../../../../hooks/useNumberFormatter';
import { useTranslation } from 'react-i18next';
import HeaderReport from '../../components/HeaderReport';
import ReusableIcon from '../../../../Reports/ExtemdedReport/components/shared/ReusableIcon';
import CompositionIgr from './sections/CompositionIgr';
import BidAmountIgr from './sections/BidAmountIgr';
import ApprovedProjectsIgr from './sections/ApprovedProjectsIgr';
import PendingProjectsIgr from './sections/PendingProjectsIgr';
import CompositionWalletCard from '../../components/CompositionWalletCard';
import DisbursementProjectsIgr from './sections/DisbursementProjectsIgr';
import PmrIgr from './sections/PmrIgr';
import { ExpiredDisbursementsCard } from '../../../../Reports/ExtemdedReport/components/GeneralInformation/shared/ExpiredDisbursementsCard';

export const gradientColors = ['#0b396e', '#3975c8', '#4fa0a5', '#f39f2e', '#ffd700'];

interface OnePagerReportProps {
  data: {
    loan?: any;
    igr?: any;
    tcp?: any;
  };
  generalData: any;
  title: string;
  filtersApplied: any;
  portfolioName: any;
  isPdfExport?: boolean;
}

const OnePagerReportIgr: React.FC<OnePagerReportProps> = ({ data, title, generalData, filtersApplied, portfolioName, isPdfExport = false }) => {
  const { t } = useTranslation();
  const { formatMillions } = useNumberFormatter();

  const renderSection = (sectionData: any, title: string) => {
    if (!sectionData) return null;

    const { bidAmount, composition, approvedprojects, singleCard, pmr, sectors } = sectionData;

    const dataSize = sectors.length;

    return (
      <div className="section content-background">
        <header className="header-content">
          <p>{t('one_pager_report.igr_title')}</p>
          <ReusableIcon
            title={title}
            color="#F1AF43"
          />
        </header>

        <div className="c-charts-igr">
          <CompositionIgr
            t={t}
            composition={composition}
          />

          <BidAmountIgr
            t={t}
            formatMillions={formatMillions}
            bidAmount={bidAmount}
          />

          <ApprovedProjectsIgr
            t={t}
            approvedprojects={approvedprojects}
            formatMillions={formatMillions}
          />

          <PendingProjectsIgr
            t={t}
            singleCard={singleCard}
          />

          <CompositionWalletCard
            sectors={sectors}
            dataSize={dataSize}
            colors={gradientColors.slice(0, dataSize)}
            isPdfExport={isPdfExport}
          />

          <ExpiredDisbursementsCard quantity={singleCard?.projectsOverdueDisbursement} />

          <DisbursementProjectsIgr
            t={t}
            generalData={generalData}
          />

          <PmrIgr
            pmr={pmr}
          />
        </div>
      </div >
    );
  };

  return (
    <section className="c-main">
      <HeaderReport
        portfolioName={portfolioName}
        filtersApplied={filtersApplied}
        generalData={generalData}
      />

      <article className="content">{data.igr && renderSection(data.igr, title)}</article>
    </section>
  );
};

export default OnePagerReportIgr;
